import { createContext } from "react";
import { UseGoogleMapsApiKey } from "../types/UseGoogleMapsApiKey";

export const GoogleMapsApiKeyContext = createContext<UseGoogleMapsApiKey>({
    hasLoaded: false
});
